'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCheckedPlaylistsArray = exports.getMyPlaylisTracks = exports.getMyPlaylist = exports.getFilteredPlaylists = exports.getMyPlaylists = undefined;

var _invertBy2 = require('lodash/invertBy');

var _invertBy3 = _interopRequireDefault(_invertBy2);

var _get2 = require('lodash/get');

var _get3 = _interopRequireDefault(_get2);

var _find2 = require('lodash/find');

var _find3 = _interopRequireDefault(_find2);

var _reselect = require('reselect');

var _myPlaylists = require('helpers/my-playlists');

var _playlists = require('selectors/playlists');

var _utils = require('helpers/utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _getMyPlaylists = function _getMyPlaylists(state) {
  return state.myPlaylists.myPlaylistsData || [];
};
var _getMyPlaylist = function _getMyPlaylist(state, guid) {
  return (0, _find3.default)((0, _get3.default)(state, 'myPlaylists.myPlaylistsData'), { guid: guid }) || {};
};
var _getCheckedPlaylists = function _getCheckedPlaylists(state) {
  return state.myPlaylists.checkedPlaylists;
};
var _getKw = function _getKw(state) {
  return state.myPlaylists.kw;
};

var filteredFields = ['name'];

var getMyPlaylists = exports.getMyPlaylists = (0, _reselect.createSelector)([_getMyPlaylists], _myPlaylists.processMyPlaylists);

var getFilteredPlaylists = exports.getFilteredPlaylists = (0, _reselect.createSelector)([getMyPlaylists, _getKw], function (objects, kw) {
  return (0, _utils.filterObjectsByKws)({ objects: objects, fields: filteredFields, kw: kw });
});

var getMyPlaylist = exports.getMyPlaylist = (0, _reselect.createSelector)([_getMyPlaylist], _myPlaylists.processMyPlaylist);

var getMyPlaylisTracks = exports.getMyPlaylisTracks = (0, _reselect.createSelector)([getMyPlaylist, _playlists.getAllTracks], _myPlaylists.processMyPlaylistTracks);

var getCheckedPlaylistsArray = exports.getCheckedPlaylistsArray = (0, _reselect.createSelector)([_getCheckedPlaylists], function (playlists) {
  return (0, _invertBy3.default)(playlists).true || [];
});


//////////////////
// WEBPACK FOOTER
// ./src/selectors/my-playlists.js
// module id = 361
// module chunks = 1